export const API_BASE_URL = 'https://api.example.com'; // 替换为实际的API地址 


export const AppConfig = {
  primaryColor: '#00BF58',
  primaryButtonColor: '#00BF58',
  shoppingButtonColor: '#F35621', 
  primaryTextColor: '#ffffff',
  shoppingTextColor: '#ffffff',
  secondaryButtonColor: '#EBEBEB',
  secondaryTextColor: '#242424',
  blueHintColor: '#075AFF', 
  // 会员等级配置
  memberLevels: {
    1: {
      name: '青铜',
      gradient: ['#B8860B','#CD7F32', '#B8860B'], // 青铜色渐变
      textColor: '#FFFFFF',
      shadowColor: '#8B4513',
      gradientDirection: { start: { x: 0, y: 0 }, end: { x: 1, y: 1 } }
    },
    2: {
      name: '白银',
      gradient: ['#D6DCD6','#EBEBEA', '#D6DCD6'], // 银白色渐变
      textColor: '#FFFFFF',
      shadowColor: '#696969',
      gradientDirection: { start: { x: 0, y: 0 }, end: { x: 1, y: 1 } }
    },
    3: {
      name: '黄金',
      gradient: ['#FFA500','#FFD700', '#FFA500'], // 金黄色渐变
      textColor: '#CD7F32',
      shadowColor: '#FFFFFF',
      gradientDirection: { start: { x: 0, y: 0 }, end: { x: 1, y: 1 } }
    },
    4: {
      name: '铂金',
      gradient: ['#BCC6CC','#E5E4E2', '#BCC6CC'], // 铂金色渐变
      textColor: '#FFFFFF',
      shadowColor: '#696969',
      gradientDirection: { start: { x: 0, y: 0 }, end: { x: 0.8, y: 1 } }
    },
    5: {
      name: '钻石',
      gradient: ['#AC84FF','#E5F7FA', '#AC84FF'], // 钻石蓝紫渐变
      textColor: '#FFFFFF',
      shadowColor: '#4B0082',
      gradientDirection: { start: { x: 0, y: 0 }, end: { x: 0.8, y: 1 } }
    },
    6: {
      name: '黑曜',
      gradient: ['#000000','#676464', '#000000'], // 黑曜石渐变
      textColor: '#FFA500',
      shadowColor: '#000000',
      gradientDirection: { start: { x: 0, y: 0 }, end: { x: 0.8, y: 1 } }
    }
  }
}